export default __webpack_public_path__ + "static/media/lua.a03cbf1f.jpg";